import { render, staticRenderFns } from "./ONotifications.vue?vue&type=template&id=21a4b69e"
import script from "./ONotifications.vue?vue&type=script&lang=js"
export * from "./ONotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports